module.exports = __webpack_public_path__ + "img/gn.1ce64523.svg";